import { ComponentPropsWithoutRef } from 'react';
import './HeaderH1.css';

export type HeaderH1Props = {
  textValue: string;
  [key: string]: unknown;
} & ComponentPropsWithoutRef<'h1'>;

export const HeaderH1 = ({ textValue, ...rest }: HeaderH1Props) => {
  return (
    <div className="HeaderH1-wrapper HeaderH1-wrapper--border">
      <div className="HeaderH1-border">
        <h1 className="HeaderH1 HeaderH1--border" {...rest}>
          {textValue}
        </h1>
      </div>
    </div>
  );
};
